// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComponentNavigationContent-base__Vzo5L{display:flex;flex-direction:column;min-height:0}.ComponentNavigationContent-base__Vzo5L:not(:first-child){flex:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ComponentNavigationContent-base__Vzo5L"
};
export default ___CSS_LOADER_EXPORT___;
